//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[],[[["name","value"],"GetStringPreference",{R_:{isFound:''}},1,0],[["name","value"],"SetStringPreference",{},2,0],[["name","nValues","values"],"GetStringArrayPreference",{R_:{isFound:''}},1,0],[["name","values"],"SetStringArrayPreference",{},2,0],[["name","value"],"GetIntegerPreference",{R_:{isFound:''}},1,0],[["name","value"],"SetIntegerPreference",{},2,0],[["name","nValues","values"],"GetIntegerArrayPreference",{R_:{isFound:''}},1,0],[["name","values"],"SetIntegerArrayPreference",{},2,0],[["name","value"],"GetDoublePreference",{R_:{isFound:''}},1,0],[["name","value"],"SetDoublePreference",{},2,0],[["name","nValues","values"],"GetDoubleArrayPreference",{R_:{isFound:''}},1,0],[["name","values"],"SetDoubleArrayPreference",{},2,0]],[]];
SPLM.Preferences.RoutingUserPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingUserPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;